// ============================================================================
// "My subs" for an account manager, the way the Subcontractors hub means it
// (item #683): a sub with a running or booked assignment on a building I
// manage is mine, whatever its markets. Same two tables, same statuses, so the
// Onboarding tab's "Mine" and the hub's "My subs" agree.
// ============================================================================
import { useEffect, useState } from 'react';
import { supabase } from '../../../shared/supabase';
import { useReader } from '../../../shared/save-path';

export function useMySubIds(me: string | null): { ids: Set<string>; loading: boolean } {
  const [ids, setIds] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(!!me);
  const [tick, setTick] = useState(0);
  useReader(['service_assignments', 'facilities'], () => setTick((n) => n + 1));

  useEffect(() => {
    let cancelled = false;
    if (!me) {
      setIds(new Set());
      setLoading(false);
      return;
    }
    setLoading(true);
    void (async () => {
      const [asg, fac] = await Promise.all([
        supabase
          .from('service_assignments')
          .select('provider_id, facility_id')
          .in('assignment_status', ['Active', 'Scheduled']),
        supabase
          .from('facilities')
          .select('facility_id')
          .eq('account_manager_eid', me)
          .in('status', ['Active', 'Onboarding', 'Pending']),
      ]);
      if (cancelled) return;
      const mine = new Set(((fac.data ?? []) as Array<{ facility_id: string }>).map((f) => f.facility_id));
      const out = new Set<string>();
      for (const a of (asg.data ?? []) as Array<{ provider_id: string | null; facility_id: string }>) {
        if (a.provider_id && mine.has(a.facility_id)) out.add(a.provider_id);
      }
      setIds(out);
      setLoading(false);
    })();
    return () => {
      cancelled = true;
    };
  }, [me, tick]);

  return { ids, loading };
}
